import { render, staticRenderFns } from "./PsDetailInfo.vue?vue&type=template&id=d8ef78ac&scoped=true&"
import script from "./PsDetailInfo.vue?vue&type=script&lang=js&"
export * from "./PsDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./PsDetailInfo.vue?vue&type=style&index=0&id=d8ef78ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ef78ac",
  null
  
)

export default component.exports